export async function executeQuery(
  graphQLQuery,
  shopDomain,
  storefrontAccessToken = ''
) {
  try {
    console.log(
      'Executing GraphQL Query:',
      graphQLQuery,
      window.Shopify.shop,
      window.theme.apiKeys.storefrontAccessToken
    );
    const response = await fetch(
      `https://${shopDomain || window.Shopify.shop}/api/2026-01/graphql`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/graphql',
          'X-Shopify-Storefront-Access-Token':
            storefrontAccessToken || window.theme.apiKeys.storefrontAccessToken,
        },
        body: graphQLQuery,
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error:', error);
    return [];
  }
}
